/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { postRequest, getRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddDownloadFile = () => {
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [file, setFile] = useState(null);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Fetch active categories to populate the dropdown
        const fetchCategories = async () => {
            try {
                const res = await getRequest('download-categories?is_active=true');
                setCategories(res?.data || []);
            } catch (err) {
                console.error('Error fetching categories:', err);
                toast.error("Failed to load categories.");
            }
        };
        fetchCategories();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!categoryId) {
            toast.error("Please select a category");
            return;
        }

        if (!title.trim()) {
            toast.error("Please enter a file title");
            return;
        }

        if (!file) {
            toast.error("Please select a PDF file to upload");
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('category_id', categoryId);
        formData.append('file', file);

        setLoading(true);
        try {
            await postRequest('download-files', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success("File uploaded successfully!");
            navigate('/downloads/files');
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Something went wrong while uploading file.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid mt-4">
            <div className="card shadow-lg mx-auto" style={{ maxWidth: '600px', borderRadius: '15px' }}>
                <div className="card-header text-white" style={{ background: 'linear-gradient(135deg, #0054A6 0%, #007BFF 100%)', borderRadius: '15px 15px 0 0' }}>
                    <h5 className="mb-0 font-weight-bold"><i className="fa fa-upload mr-2"></i> Upload Download File</h5>
                </div>
                <div className="card-body p-4">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-4">
                            <label className="font-weight-bold text-dark">Category <span className="text-danger">*</span></label>
                            <select 
                                className="form-control" 
                                value={categoryId} 
                                onChange={(e) => setCategoryId(e.target.value)}
                                style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                            >
                                <option value="">-- Select Category --</option>
                                {categories.map(cat => (
                                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group mb-4">
                            <label className="font-weight-bold text-dark">File Title <span className="text-danger">*</span></label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={title} 
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder="e.g. Newsletter June 2020 Vol 02; No.01" 
                                style={{ borderRadius: '8px', border: '1px solid #ced4da' }}
                            />
                        </div>
                        <div className="form-group mb-4">
                            <label className="font-weight-bold text-dark">PDF File <span className="text-danger">*</span></label>
                            <input 
                                type="file" 
                                className="form-control-file" 
                                accept="application/pdf"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                        </div>
                        <div className="text-center mt-5">
                            <button 
                                type="submit" 
                                className="btn btn-primary px-5 py-2 font-weight-bold shadow-sm"
                                disabled={loading}
                                style={{ borderRadius: '8px', background: 'linear-gradient(135deg, #0054A6 0%, #007BFF 100%)', border: 'none' }}
                            >
                                {loading ? 'Uploading...' : 'Upload File'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddDownloadFile;
